<script>
  import lodash from 'lodash';
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellVialsTotal',
    extends: TableCellBase,
    data() {
      return {
        fields: [
          'scit_vials_total',
          'slit_vials_total',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.monthObj[field])
        }, 0);
      },
    },
  };
</script>
